import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import ChargeFactory from "../../Entity/Factories/ChargeFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ChargeInterface } from "../../Entity/Entities/Charge/ChargeInterface";
import Translator from "../../Translation/Translator";

export default function* chargeUpdate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_UPDATE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_CHARGE_UPDATE_REQUEST
    });

    const res = yield call(Http.put, `charge/${action.payload?.chargeId}`, {
      ...action.payload?.charge
    });

    const charge: ChargeInterface = ChargeFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_CHARGE_UPDATE_SUCCESS
    });

    if(action.payload?.updateMemo){
      // yield put({
      //   type: Constants.SNACKBAR_ADD_MESSAGE,
      //   payload: {
      //     message: Translator.trans("snackbar-message-charge-memo-updated-successfully"),
      //     type: "success"
      //   }
      // });
    } else if(action.payload?.removeMemo){
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans("snackbar-message-charge-memo-removed-successfully"),
          type: "success"
        }
      });
    } else {
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans("snackbar-message-charge-updated-successfully"),
          type: "success"
        }
      });
    }

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, charge);
    }

  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CHARGE_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeUpdate() {
  yield takeEvery(Constants.GLOBAL_CHARGE_UPDATE_START, chargeUpdate);
}
